import React from 'react';

export default (_props) => {
  const { className, size, large, small, ...props } = _props;

  // small icon
  if ((size && size.toLowerCase() === 'small') || small) {
    return (
      <svg width="24" height="24" viewBox="0 1 24 25" className={`audiicon audiicon-small ${className ? className : ''}`} {...props}>
        <path d="M 2.601 7.67 L 3.301 6.97 L 11.951 15.61 L 20.601 6.97 L 21.301 7.67 L 11.951 17.03 L 2.601 7.67 Z" fill="black" />
      </svg>
    );
  }

  // large icon
  return (
    <svg width="48" height="48" viewBox="0 1 24 25" className={`audiicon audiicon-large ${className ? className : ''}`} {...props}>
      <path d="M 2.601 7.67 L 3.301 6.97 L 11.951 15.61 L 20.601 6.97 L 21.301 7.67 L 11.951 17.03 L 2.601 7.67 Z" fill="black" />
    </svg>
  );
};